<template>
    <!-- 工厂个人中心 -->
    <div class="rzy-page">
      <el-tabs :tab-position="'left'">
        <el-tab-pane label="账号安全">
          <user-central-item @btn-click="$refs.changePwdDialog.show()" :img-src="require('@/assets/password.png')" title="密码" core-value="*****" btn-value="修改密码"/>
          <user-central-item @btn-click="$refs.changePhone.show()" :img-src="require('@/assets/phone.png')" title="手机号"
          :core-value="this.userInfo.phone?this.utils.hidePhone(this.userInfo.phone):'未绑定'" btn-value="修改手机号"/>
          <user-central-item @btn-click="getFactoryId();$refs.qrCode.show()" :img-src="require('@/assets/password.png')" title="工厂二维码" btn-value="显示二维码"/>
        </el-tab-pane>
      </el-tabs>
      <change-pwd-dialog ref="changePwdDialog"/>
      <change-phone ref="changePhone"/>
      <qr-code ref="qrCode" :text="this.factoryId" title="工厂二维码"></qr-code>
    </div>
</template>
<script>
import { userCentralItem, changePwdDialog, changePhone } from './components'
import QrCode from '../../components/projectComponents/qrCode.vue'
export default {
  components: {
    userCentralItem,
    changePwdDialog,
    changePhone,
    QrCode
  },
  data() {
    return {
      factoryId: '',
      userInfo: {
        phone: '',
        unionId: ''
      }
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    // 获取工厂ID
    getFactoryId() {
      this.factoryId = sessionStorage.getItem('factoryId')
    },
    // 获取用户信息
    getUserInfo() {
      const phone = JSON.parse(sessionStorage.getItem('userInfo')).phone
      this.userInfo.phone = phone
      console.log(this.userInfo.phone)
    }
  }
}
</script>
<style lang="less" scoped>
.el-tabs{
  margin: 5% 10% 10% 5%;
}

</style>
